import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { quotesInfiniteQueryOptions } from '@/hooks'
import {
  ALL_QUOTE_STATUSES,
  buildQuotesQueryOptions,
  QuotesPage,
} from '@/pages/quotes/QuotesPage'

const QuotesSearchSchema = z.object({
  status: z.enum(ALL_QUOTE_STATUSES).optional(),
  archived: z.boolean().default(false),
})

export const Route = createFileRoute('/_authenticated/_dashboard/quotes/')({
  validateSearch: QuotesSearchSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureInfiniteQueryData(
      quotesInfiniteQueryOptions(buildQuotesQueryOptions(deps.search)),
    ),
  component: QuotesPage,
})
